{
  "$schema": "https://json-schema.org/draft/2019-09/schema",
  "title": "Wix component manifest schema",
  "type": "object",
  "properties": {
    "referredType": {
      "description": "Reference to manifest to inherit from by URL or by comp type",
      "$ref": "#/$defs/referredType"
    },
    "selector": {
      "description": "String describing how the user want us to select the component from the DOM",
      "$ref": "#/$defs/selector"
    },
    "displayName": {
      "description": "The name of the component/widget",
      "type": "string"
    },
    "compType": {
      "description": "String describing the current editor elements registry keys - to be deleted with final implementation",
      "$ref": "#/$defs/compType"
    },
    "definitions": {
      "description": "Definitions of rules, properties and behaviors that are needed for the component/widget",
      "type": "object",
      "properties": {
        "editingBehaviors": {
          "description": "The editing behaviors ( relevant only for editor ) of the component/widget, it can be a single editing behaviors object or an array of refs and editingBehaviors",
          "$ref": "#/$defs/editingBehaviors"
        },
        "style": {
          "description": "The styles properties of the component/widget, it can be a single style object or an array of refs and style",
          "$ref": "#/$defs/style"
        }
      },
      "additionalProperties": false
    },
    "elements": {
      "description": "The children of the container component/widget, representing the structure of the component/widget",
      "type": "object",
      "patternProperties": {
        "^[a-zA-Z0-9]+$": {
          "$ref": "#"
        }
      }
    },
    "presets": {
      "description": "The design presets that are available for this component/widget",
      "type": "object",
      "patternProperties": {
        "^[a-zA-Z0-9]+$": {
          "$ref": "#/$defs/preset"
        }
      }
    }
  },
  "additionalProperties": false,
  "$defs": {
    "editingBehaviors": {
      "type": "object",
      "description": "The editing behaviors of the component/widget",
      "properties": {
        "selectable": {
          "description": "Whether the component/widget is selectable in the editor by the user",
          "type": "boolean"
        },
        "removable": {
          "description": "Whether the component/widget is removable in the editor by the user",
          "type": "boolean"
        }
      },
      "additionalProperties": false
    },
    "style": {
      "description": "The styles properties of the component/widget",
      "type": "object",
      "patternProperties": {
        "^[a-zA-Z0-9]+$": {
          "type": "object",
          "properties": {
            "shapeOf": {
              "description": "The type of the style",
              "type": "string",
              "enum": [
                "number",
                "length",
                "backgroundSize",
                "fontSize",
                "marginTop",
                "marginRight",
                "marginBottom",
                "marginLeft",
                "margin",
                "paddingTop",
                "paddingRight",
                "paddingBottom",
                "paddingLeft",
                "padding",
                "top",
                "right",
                "bottom",
                "left",
                "height",
                "width",
                "backgroundColor",
                "borderColor",
                "color",
                "borderWidth",
                "borderRadius",
                "font",
                "fontFamily",
                "boxShadow",
                "opacity",
                "alignSelf",
                "justifyContent"
              ]
            },
            "editableStates": {
              "description": "The states that the style can be edited in",
              "type": "array",
              "items": {
                "type": "string"
              }
            }
          },
          "additionalProperties": false
        }
      }
    },
    "referredType": {
      "description": "Reference to manifest to inherit from by URL or by comp type",
      "type": "string"
    },
    "selector": {
      "description": "String describing how the user want us to select the component from the DOM",
      "type": "string"
    },
    "compType": {
      "description": "String describing the current editor elements registry keys - to be deleted with final implementation",
      "type": "string"
    },
    "preset": {
      "type": "object",
      "properties": {
        "displayName": { "type": "string" },
        "imgUrl": { "type": "string" },
        "cssUrl": { "type": "string" }
      },
      "required": ["displayName"],
      "additionalProperties": false
    }
  }
}
